// extracted by mini-css-extract-plugin
export default {"setting":"setting_setting__oXvIM","setting_navbar":"setting_setting_navbar__9JlwI","setting_container":"setting_setting_container__jZsWl"};